<template>
  <v-container id="container-wrap" fluid pa-0 v-show="isAuthorized && isShow">
  <Snackbar ref="snackbar" />

    <v-row class="action-bar">
      <v-col cols="1"></v-col>
      <v-col cols="3" class=" text-left">
        <v-btn color="primary" outlined @click="handleDownload">Download</v-btn>

      </v-col>
      <v-col cols="4" class="text-center">
        <pdf-navigation :page="page" :pages-count="pagesCount" @increment="page++" @decrement="page--"/>
      </v-col>
      <v-col cols="3" class="text-right">
        <v-btn v-if="!isPaid && !showPaymentForm" color="success" @click="showPaymentForm=true">Pay Now</v-btn>
        <v-btn v-if="isPaid" color="success" @click="showReceipt=true">Paid - View Receipt</v-btn>
      </v-col>
      <v-col cols="1"></v-col>
    </v-row>

    <v-row no-gutters v-show="showPaymentForm || showReceipt" class="content elevation=2" style="flex-grow:0; padding-bottom:2em">
      <v-col cols="2"></v-col>
      <v-col cols="8">
        <div class="mx-auto pa-3" style="background-color:white;width:100%;">
          <h2 class="text-left">{{showPaymentForm ? "Credit Card Payment" : "Payment Receipt"}}</h2>
          <v-row>
            <v-col class="py-0" cols="8">
              <div v-if="showReceipt">
                <v-row>
                  <v-col cols="4" class="text-right pb-0" style="font-weight: 500">Payment Date: </v-col>
                  <v-col cols="8" class="pb-0">{{paymentDate}}</v-col>
                </v-row>
                <v-row>
                  <v-col cols="4" class="text-right pb-0" style="font-weight: 500">STRIPE Transaction ID: </v-col>
                  <v-col cols="8" class="pb-0">{{transactionId}}</v-col>
                </v-row>
              </div>
              <form v-show="showPaymentForm">
                <div id="payment-element"></div>
              </form>
            </v-col>
            <v-col class="py-0" cols="4">
              <v-row>
                <v-col cols="8" class="text-right" style="font-weight:500">Invoice:</v-col>
                <v-col cols="4" class="text-right" style="font-weight:500">{{invoiceCode}}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" class="text-right py-0" style="font-weight:500">Subtotal:</v-col>
                <v-col cols="4" class="text-right py-0">{{formatCurrency(subtotal)}}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" class="text-right py-0" style="font-weight:500">Tax:</v-col>
                <v-col cols="4" class="text-right py-0">{{formatCurrency(tax)}}</v-col>
              </v-row>
              <v-row>
                <v-col cols="8" class="text-right py-0" style="font-weight:500">Total:</v-col>
                <v-col cols="4" class="text-right py-0">{{formatCurrency(subtotal + tax)}}</v-col>
              </v-row>
              <v-row>
                <v-col cols="12" class="text-right pb-0" style="font-weight:500">
                  <a elevation="2" @click="showPaymentForm=false;showReceipt=false">Close</a>
                  <v-btn v-if="showPaymentForm" class="ml-5" elevation="2" color="success" @click="handlePay">Pay Now</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

        </div>
      </v-col>
      <v-col cols="2"></v-col>
    </v-row>

    <v-row v-if="errorMeessage">
      <div class="text-center">
        {{ errorMessage }}
      </div>

    </v-row>

    <v-row id="invoiceWrapper" no-gutters class="content">
      <v-col cols="2"></v-col>
      <v-col cols="8">
        <v-card class="elevation-2">
          <v-card-text>
            <div style="display: relative;">
              <canvas
                ref="canvas"
                class="sx-absolute-centered"
                :style="{ zIndex: 1 }"
              />
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="2"></v-col>
      <v-spacer></v-spacer>
    </v-row>

    <invoice-footer></invoice-footer>
  </v-container>
</template>

<script>
import pdf from '@/mixins/pdf';
import InvoiceFooter from '@/components/SignPdf/Sign/InvoiceFooter.vue';
import { saveAs } from 'file-saver';
import PdfNavigation from '@/components/SignPdf/PdfNavigation';
import Snackbar from '../components/Snackbar';
import moment from 'moment';

export default {
  components: { InvoiceFooter, Snackbar, PdfNavigation },
  mixins: [pdf],
  data() {
    return {
      isAuthorized: false,
      file: '',
      documentName: '',
      token: '',
      environment: '',
      fileName: '',
      invoiceId: '',
      invoiceCode: '',
      subtotal: 0,
      tax: 0,
      currencyCode: 'CAD',
      showPaymentForm: false,
      showReceipt: false,
      isPaid: false,
      //STRIPE:
      clientSecret: null,
      stripe: null,
      elements: null,
      paymentElement: null,
      //receipt:
      paymentDate: '',
      transactionId: '',
      invoiceStatusId: null,
      errorMessage: ''
    };
  },
  beforeRouteEnter(to, from, next) {
    if (to.query && to.query.token && to.query.environment) {
      next(vm => vm.init(to.query.token, to.query.environment));
    } else {
      alert('Error: Opening Invoice');
    }
  },
  mounted() {
    const stripeScript = document.createElement('script');
    stripeScript.setAttribute('src', 'https://js.stripe.com/v3/');
    document.head.appendChild(stripeScript);
  },
  methods: {
    async init(token, environment) {
      this.environment = environment;
      this.$api.setSxEnvironment(this.environment);
      this.isAuthorized = await this.authorize(token);
      if (this.isAuthorized) {
        this.token = token;
        this.isShow = true;
        await this.getDocument(token);
      }
    },
    async authorize(token) {
      try {
        const res = await this.$api.post(`invoice-transactions/authorize`, { token });
        this.isError = res.status !== 200;
        return res.data === true;
      } catch (error) {
        return false;
      }
    },
    async getDocument(token) {
      try {
        const res = await this.$api.post(`invoice-transactions/get-document`, { token });
        if (res.status === 200) {
          this.file = res.data.file.fileContents;
          this.downloadLink = res.data.downloadLink;
          this.invoiceId = res.data.invoiceId;
          this.invoiceCode = res.data.invoiceCode;
          this.subtotal = res.data.subtotal;
          this.tax = res.data.tax;
          this.currencyCode = res.data.currencyCode || 'CAD';
          this.isPaid = res.data.isPaid;
          this.clientSecret = res.data.clientSecret;
          this.documentName = res.data.fileDLModel.fileName;
          this.invoiceStatusId = res.data.invoiceStatusId;
          if (this.invoiceStatusId === 4) {
            this.errorMessage = 'Invoice has been Cancelled';
            this.showPaymentForm = false;
            return;
          }

          if (!this.isPaid) {
            if (!res.data.publicKey || !this.clientSecret) {
              //TODO show message
              this.message = 'Payment method not setup in SystemX'
              this.showPaymentForm = false;
              return;
            }
            this.initStripe(res.data.publicKey);
          } else {
            this.paymentDate = moment(res.data.paymentDate).format('MMM DD, YYYY hh:MM A');
            this.transactionId = res.data.stripeTransactionId;
          }
        }
      } catch (error) {
        console.log(error)
      }
    },

    initStripe(pk) {
      this.stripe = Stripe(pk);
      const appearance = { theme: 'stripe' };
      this.elements = this.stripe.elements({appearance, clientSecret: this.clientSecret});
      this.paymentElement = this.elements.create('payment');
      this.paymentElement.mount('#payment-element');
    },

    async getPdfData() {
      let data = await this.loadPdfDocument(this.file);
      return await data.pdfDoc.save();
    },

    async handleDownload() {
      saveAs(this.downloadLink, this.documentName);
    },

    showError(e) {
      this.$refs.snackbar.showError(`Error: ${e}`);
    },
    showSuccess(e) {
      this.$refs.snackbar.showSuccess(e);
    },

    async handlePay(e) {
      e.preventDefault();
      if (this.isPaid) return
      const res = await this.stripe.confirmPayment({
        elements: this.elements,
        redirect: 'if_required'
      });
      if (!res) this.showError('An unexpected error occured');
      else if (res.error) this.handlePaymentError(res.error)
      else if (res.paymentIntent) this.handlePaymentSuccess(res.paymentIntent);
    },

    handlePaymentError(err) {
      this.showError(err.message);
    },

    async handlePaymentSuccess(paymentIntent) {
      this.showSuccess('Payment succeeded');
      this.isPaid = true;
      this.showPaymentForm = false;
      this.showReceipt = true;

      const data = {
        token: this.token,
        transactionId: paymentIntent.id,
      }
      this.$api.post(`invoice-transactions/on-payment-success`, data);
      this.transactionId = paymentIntent.id;
      this.paymentDate = moment().format('YYYY-MM-DD HH:MM');
    },

    formatCurrency(val) {
			if (!this.currencyFormatter) {
				this.currencyFormatter = new Intl.NumberFormat('en-CA', {
					style: 'currency',
					currency: this.currencyCode,
				});
			}
			return this.currencyFormatter.format(val);
		},

  },
};
</script>

<style lang="scss">
@font-face {
  font-family: 'BetterGrade';
  src: url('/BetterGrade.ttf');
  font-size: 50px;
}

.container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
}

.content {
  flex-grow: 1;
  overflow-x: auto;
  background-color: #eae8ea;
}
html {
  margin: 0;
  padding: 0;
  overflow: hidden;
}
.action-bar {
  background-color: #f0f0f0 !important;
  max-height: 60px;
}

/* Hide scrollbar but keep scroll functionality */
#invoiceWrapper::-webkit-scrollbar {
  display: none; /* Chrome */
}
#invoiceWrapper {
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}
</style>
